import { Component, type ErrorInfo, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import "@kira/ui/theme.css";
import "./styles.css";
import { App } from "./App";
import "./theme/01-tokens.css";
import "./theme/02-iron-atmosphere.css";
import "./theme/03-ornaments.css";
import "./theme/04-theme-bridge.css";
import "./theme/06-light-fix.css";
import "./theme/07-app-adaptation.css";
import "@kira/ui/brand.css";
import "./official-theme.css";


class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    window.dispatchEvent(
      new CustomEvent("kira:client-error", {
        detail: { message: error.message, stack: error.stack, componentStack: info.componentStack },
      }),
    );
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal" role="alert">
        <span className="fatal__code">出了点问题</span>
        <h1>KIRA 暂时没有打开</h1>
        <p>你的内容都还在，请重新加载试试。</p>
        <button type="button" onClick={() => window.location.reload()}>重新加载</button>
      </main>
    );
  }
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      window.dispatchEvent(new CustomEvent("kira:client-error", { detail: { message: String(error), phase: "sw-register" } }));
    });
  });
}
